import BigNumber from 'bignumber.js';
import { Address, encodeFunctionData, WalletClient } from 'viem';

import stakingTokenAbi from 'modules/api/abi/LiquidStakingToken';
import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { convertToWei } from 'modules/api/utils';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

export async function stake(
  walletClient: WalletClient,
  data: {
    amount: BigNumber;
  },
): Promise<Address> {
  const { amount } = data;

  const encodedData = encodeFunctionData({
    abi: stakingTokenAbi,
    functionName: 'stake',
    args: [convertToWei(amount)],
  });

  const txHash = await walletClient.sendTransaction({
    to: LIQUID_STAKING_TOKEN_ADDRESS,
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address),
  });

  return txHash;
}
